import { RolePermissionsGrid } from '@/modules/admin/components/role-permissions-grid';

export default function RolePermissionsPage() {
	return (
		<div className='flex flex-col gap-6 p-4'>
			<div>
				<h1 className='text-base font-semibold'>Role Permissions</h1>
				<p className='text-xs text-muted-foreground'>
					Manage which actions each role can perform across the app. Changes apply to all users with that role on
					their next page load.
				</p>
			</div>
			<RolePermissionsGrid />
		</div>
	);
}
